export default __webpack_public_path__ + "static/media/626.8e8efd36.gif";